import { GetSalesModesTypesAndTagsV2 } from "../ModeOfSale/ModeOfSales/helper";
import { toast } from "react-toastify";
import { t } from "i18next";
import {
    CLICK_AND_COLLECT_ID,
    DINE_IN_ID,
    TAKE_AWAY_ID,
} from "../../../constants/index";
import { detailedDiff } from "deep-object-diff";
import { setIds } from "./store";

export function groupByShopId(input: any) {
    const grouped: Record<string, any> = {};

    // Parcourir tous les éléments
    Object.values(input).forEach((item: any) => {
        const data = item.data;

        Object.entries(data).forEach(([key, value]: [string, any]) => {
            const shopId = value.shopId;

            if (!grouped[shopId]) {
                grouped[shopId] = {
                    data: {},
                    franchiseId: item.franchiseId,
                    isShop: item.isShop,
                    operatorId: item.operatorId,
                    shopId: [shopId],
                    userId: item.userId,
                    uuidUser: item.uuidUser,
                };
            }

            grouped[shopId].data[key] = value;
        });
    });

    // Retourner un tableau
    return Object.values(grouped);
}

export function elementsCommuns(arrayShop: any, arrayMI: any) {
    // Utilisation de la méthode filter pour obtenir les éléments communs
    var elementsCommuns = arrayMI.filter(function (element: any) {
        return arrayShop.includes(element);
    });

    return elementsCommuns;
}
export function getUnion(array1: any, array2: any) {
    let data: any = [];
    let max: any = array2.length > array1.length ? array2 : array1;
    let min: any = array2.length < array1.length ? array2 : array1;
    if (array1.length === array2.length) {
        min = array1;
        max = array2;
    }
    max.forEach((el: any) => {
        if (min.indexOf(el) !== -1) {
            data.push(el);
        }
    });
    return data;
}

export async function getShopsRelations(
    isValidation: boolean,
    dataTable: any,
    franchiseID: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    try {
        let data: any = [];
        let shops: any = dataTable?.othersData?.dataShops;
        let shopIds = isValidation
            ? [
                  "0",
                  ...shops.map((x: any) => {
                      return x.shopId;
                  }),
              ]
            : ["0"];
        const allData: any = await GetSalesModesTypesAndTagsV2(
            franchiseID,
            shopIds,
            fetchGlobal
        );

        for (let index = 0; index < shops.length; index++) {
            let id = shops[index].shopId;
            let shopData = allData.find((x: any) => x.shopId === id);
            let dataMOS: any = [];
            let dataSOS: any = [];
            if (shopData.modeOfSales)
                dataMOS = shopData.modeOfSales.map((x: any) => x["Id"] || x.id);

            dataSOS = shopData.ListSaleSupport || [];
            data.push({
                supportOfSale: dataSOS,
                modeOfSale: dataMOS,
                shopId: id,
            });
        }
        return data;
    } catch (e) {}
}

export function ArchiveModeOfInformation(shopsModeInformationData: any) {
    let idsAssociated: any = [];

    if (shopsModeInformationData.data !== undefined) {
        shopsModeInformationData.data.forEach((element: any) => {
            if (element.subRows !== undefined) {
                element.subRows.forEach((el: any) => {
                    idsAssociated.push(el.Id);
                });
            }
        });
    }

    idsAssociated = [...new Set(idsAssociated)];

    return idsAssociated;
}

export function ArchiveModeOfInformationFranchise(
    archivedModeInformationFranchise: any
) {
    let idsAssociated: any = [];

    if (archivedModeInformationFranchise !== undefined) {
        archivedModeInformationFranchise.forEach((element: any) => {
            idsAssociated.push(element.Id);
        });
    }

    idsAssociated = [...new Set(idsAssociated)];

    return idsAssociated;
}

export function AssociateModeOfInformation(shopsModeInformationData: any) {
    let idsAssociated: any[] = [];
    if (shopsModeInformationData.data !== undefined) {
        shopsModeInformationData.data.forEach((element: any) => {
            if (element.subRows !== undefined) {
                element.subRows.forEach((el: any) => {
                    idsAssociated.push(el.Id);
                });
            }
        });
    }
    idsAssociated = [...new Set(idsAssociated)];
    return idsAssociated;
}

export function checkIfAssociated(shopId: string, rowsShop: any, t: any) {
    let associated: any[] = [];

    rowsShop.forEach((elt: any) => {
        if (elt.shopId === shopId && elt[t("Shop")] !== undefined) {
            associated = elt.subRows;
        }
    });
    return associated;
}

export function checkIfModeOfInformationExistAndArchived(rowsShop: any) {
    let archived: any[] = [];
    if (rowsShop.length > 0) {
        rowsShop.forEach((element: any) => {
            if (element.archivedModeOfInformation !== undefined) {
                element.archivedModeOfInformation.forEach((el: any) => {
                    archived.push(el.Id);
                });
            }
        });
    }
    return archived;
}

export function ArchiveAllModeOfInformation(
    e: any,
    shopsModeInformationData: any
) {
    let idsAssociated = [0];
    let associated = [e];
    if (shopsModeInformationData.data !== undefined) {
        shopsModeInformationData.data.forEach((element: any) => {
            if (element.subRows !== undefined) {
                element.subRows.forEach((el: any) => {
                    if (el.Id === e.Id) {
                        idsAssociated.push(el.shopId);
                        associated.push(el);
                    }
                });
            }
        });
    }
    idsAssociated = [...new Set(idsAssociated)];
    return associated;
}

export async function isInformationModeConsumed(
    shopId: string,
    franchiseID: string,
    fetchGlobal: any
) {
    let dataConsumed = {};
    const url = `${process.env.REACT_APP_API_V2_URL}/settings/consumedSettingGeneral?shopId=${shopId}&franchiseId=${franchiseID}&type=informationModes`;
    try {
        const result: any = await fetchGlobal(url, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        dataConsumed = result.data;
    } catch (error) {
        toast.error(t("There's an error")!, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
            theme: "colored",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
    }
    return dataConsumed;
}
export function getDifferenceOfSaleMethodItemsInInformationMode(
    oldData: any,
    newData: any
) {
    let deleted: any = [];
    let added: any = [];
    let salesMethodsList = [TAKE_AWAY_ID, DINE_IN_ID, CLICK_AND_COLLECT_ID];

    oldData.modeOfSale.forEach((element: any) => {
        if (
            newData.modeOfSale.find((el: any) => element.value === el.value) ===
            undefined
        ) {
            if (salesMethodsList.includes(element.value) === true) {
                deleted.push(element);
            }
        }
    });
    newData.modeOfSale.forEach((element: any) => {
        if (
            oldData.modeOfSale.find((el: any) => element.value === el.value) ===
            undefined
        ) {
            if (salesMethodsList.includes(element.value) === true) {
                added.push(element);
            }
        }
    });

    const modifiedDisplayName = detailedDiff(
        oldData.advancedDisplayName,
        newData.advancedDisplayName
    );

    return {
        modifiedDisplayName,
        added,
        deleted,
    };
}

export function CountIds(idsLocalShop: string[], selectedRows: SelectedRows) {
    const selectedIdSet = new Set(selectedRows.map((v) => v.Id));

    const number = idsLocalShop.reduce(
        (count, id) => count + (selectedIdSet.has(id) ? 1 : 0),
        0
    );

    setIds(number);
}
